// extracted by mini-css-extract-plugin
export default {"health":"index_health_4iZrx"};